import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { MaterialShoreHardnessFragmentFragmentDoc } from './materialShoreHardnessFragment';
import { ToleranceFragmentFragmentDoc } from './toleranceFragment';
export type EnquiryMaterialFragmentFragment = { __typename?: 'Material', hardware: boolean, id: string, materialTypeId: string, name: string, options?: object | null, partMarkings?: object | null, surfaceRoughness?: object | null, threading: boolean, gauges: Array<{ __typename?: 'MaterialGauge', iqeValue?: string | null, mm?: string | null, name?: string | null }>, shoreHardnesses: Array<{ __typename?: 'ShoreHardness', custom: boolean, default: boolean, id: number, name: string }>, tolerancesNew: Array<{ __typename?: 'Tolerance', default: boolean, i18nKey?: string | null, id: number, name: string, quantityEnabled: boolean, value: string }> };

export const EnquiryMaterialFragmentFragmentDoc = gql`
    fragment enquiryMaterialFragment on Material {
  gauges {
    iqeValue
    mm
    name
  }
  hardware
  id
  materialTypeId
  name
  options
  partMarkings
  shoreHardnesses {
    ...materialShoreHardnessFragment
  }
  surfaceRoughness
  threading
  tolerancesNew {
    ...toleranceFragment
  }
}
    ${MaterialShoreHardnessFragmentFragmentDoc}
${ToleranceFragmentFragmentDoc}`;